import { Injectable } from '@angular/core';
import { Moment } from 'moment';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import Decimal from 'decimal.js';
import { HttpService } from '../service/http.service';
import { Currency } from '../currency';
import { ExchangeRate } from '../exchange-rate';

@Injectable({
  providedIn: 'root'
})
export class ExchangeRateService {

  constructor(
    private httpService: HttpService
  ) { }

  getExchangeRateFromEuro(currency: Currency, date: Moment): Observable<ExchangeRate> {
    return this.httpService.getExchangeRate(currency, date, true);
  }

  getExchangeRateToEuro(currency: Currency, date: Moment, confirmationBaseCurrency: Currency): Observable<ExchangeRate> {
    return this.httpService.getExchangeRateToEuro(currency, date, confirmationBaseCurrency, true);
  }

  //baseCurrency: From, targetCurrency: To
  getExchangeRateFromAnotherCurrency(baseCurrency: Currency, targetCurrency: Currency, date: Moment, confirmationBaseCurrency: Currency): Observable<ExchangeRate> {
    return this.httpService.getExchangeRateWithBaseCurrency(baseCurrency, targetCurrency, date, confirmationBaseCurrency, true);
  }

  //baseCurrency: From, targetCurrency: To
  //confirmationBaseCurrency: base currency of confirmation or quotation
  calculatePriceInCurrency(amount: Decimal, targetCurrency: Currency,
    baseCurrency: Currency, confirmationBaseCurrency: Currency, date: Moment): Observable<Decimal> {
    if (amount.isZero()) {
      return of(amount);
    }
    if (targetCurrency.id == baseCurrency.id) {
      return this.getExchangeRateFromEuro(baseCurrency, date).pipe(map(rate => {
        return amount;
      }));
    }
    if (targetCurrency.id == 1) {
      return this.getExchangeRateFromEuro(baseCurrency, date).pipe(map(rate => {
        return amount.times(rate.exchangeRate);
      }));
    } else if (baseCurrency.id == 1) {
      return this.getExchangeRateToEuro(targetCurrency, date, baseCurrency).pipe(map(rate => {
        return amount.times(rate.exchangeRate);
      }));
    } else {
      return this.getExchangeRateFromAnotherCurrency(targetCurrency, baseCurrency, date, confirmationBaseCurrency)
        .pipe(map(rate => {
          return amount.times(rate.exchangeRate);
        }));
    }
  }


}
